import { Action } from '@ngrx/store';

export const ActionTypes = {
    CORPORATE_CLIENT_UPDATE: '[Corporate Client Container] Update',
};

export class UpdateCorporateClient implements Action {
    type = ActionTypes.CORPORATE_CLIENT_UPDATE;
    payload: {
        corporateClientId: number;
        corporateClientName: string;
        allowedToOrder: boolean;
        financiallyActive: boolean;
        showPrices: boolean;
    };

    public constructor(settings: any) {
        this.payload = settings;
    }
}
